// ignore-string-externalization
import { useCallback, useEffect } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { defaultTheme } from '../Theme';
import { useLayoutContext } from '../Layout';
export var useDynamicNavBarColor = function useDynamicNavBarColor(module) {
  var isNavBarFullBleed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _useLayoutContext = useLayoutContext(),
      setNavBarBackground = _useLayoutContext.setNavBarBackground,
      setNavBarTextColor = _useLayoutContext.setNavBarTextColor,
      setNavBarBleed = _useLayoutContext.setNavBarBleed;

  var updateNavBar = useCallback(function (mod) {
    setNavBarBackground((mod === null || mod === void 0 ? void 0 : mod.backgroundColor) || defaultTheme.nav.background);
    setNavBarTextColor((mod === null || mod === void 0 ? void 0 : mod.textColor) || defaultTheme.nav.text);
  }, [setNavBarTextColor, setNavBarBackground]);
  useEffect(function () {
    if (isNavBarFullBleed) {
      setNavBarBleed(true);
      updateNavBar(module);
    } else {
      setNavBarBleed(false);
    }

    return function () {
      setNavBarBleed(false);
    };
  }, [module, isNavBarFullBleed, updateNavBar]);
  useScrollPosition(function (_ref) {
    var prevPos = _ref.prevPos,
        currPos = _ref.currPos;

    if (currPos.y < prevPos.y && prevPos.y === 0) {
      // scrolling down: reset nav bar to default colors
      updateNavBar();
    } else if (currPos.y > prevPos.y && currPos.y === 0) {
      // scrolling return to 0: reset nav bar colors to first module
      updateNavBar(module);
    }
  }, [module]);
};